module.exports = __webpack_public_path__ + "img/fi-rr-sticker.11a83781.svg";